import $ from 'jquery';

const main = () => {
    if (document.querySelector('.c-cards-property') === null) return;

    const items = document.querySelectorAll('.c-cards-property__slider');

    // IntersectionObserverのコールバック関数
    const callback = (entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // 画面内に入った時の処理
                $(entry.target).slick('slickPlay');

                // 一度処理したら監視を解除（必要に応じて）
                // observer.unobserve(entry.target);
            } else {
                // 画面外に出た時の処理
                $(entry.target).slick('slickPause');
            }
        });
    };

    // IntersectionObserverのインスタンスを作成
    const observer = new IntersectionObserver(callback, {
        root: null,         // ビューポートを基準にする
        rootMargin: '0px',
        threshold: 1      // 10%以上表示されたら処理する
    });

    // 各アイテムを監視対象にする
    items.forEach(item => {
        observer.observe(item);
    });


        // スライダーアクション
    $('.c-cards-property__slider').slick({
        slidesToShow: 1,
        autoplay: true,
        speed: 400,
        autoplaySpeed: 1500,
        infinite: true,
        dots: false,
        arrows: false,
    })
    .slick('slickPause');
}

export default main;